import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Form, Input, Button, Checkbox, Card, Alert, Text } from "antd";

import validators from "../../validators/validators";
import { FormInputField } from "../FormInputField/FormInputField";

import * as userActions from "../../actionCreators/User";

import "./LoginForm.css";
import PopupModal from "../PopupModal";

const ForgotPasswordForm = ({ forgotPassword, resetUser, history, user }) => {
  const [logoutAllDevicesCheckbox, setLogoutAllDevicesCheckbox] =
    useState(false);
  const handleSubmitForm = async (values, actions) => {
    forgotPassword({ ...values, logout_all_devices: logoutAllDevicesCheckbox });
  };

  const navigateToLoginScreen = () => {
    resetUser();
    history.push("/login");
  };

  return (
    <>
      <Card className={"LoginFormCard"}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: "20px",
            textAlign: "left",
            marginBottom: "30px",
          }}
        >
          Forgot Password
        </p>
        <p
          style={{
            color: "rgba(0, 0, 0, 0.54)",
            fontSize: "16px",
            textAlign: "left",
          }}
        >
          Please enter your email on which we will send instructions for you to
          reset your password
        </p>
        <div style={{ textAlign: "center", margin: "1%" }}></div>
        <Formik
          initialValues={{ email: "" }}
          validationSchema={validators.user.forgotpasswordSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={(values, actions) => handleSubmitForm(values, actions)}
          render={(formikProps) => {
            const { errors, handleSubmit } = formikProps;
            return (
              <>
                {Object.keys(errors).length > 0 && (
                  <Alert
                    message={errors.email || errors.auth}
                    type="error"
                    showIcon
                    style={{ marginBottom: "1.05rem", maxWidth: "300px" }}
                  />
                )}
                <Form onFinish={handleSubmit}>
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    name="email"
                    labelText="Email"
                    className="text-field"
                    hideErrorMessage={true}
                  />
                  <Form.Item>
                    <Checkbox
                      value={logoutAllDevicesCheckbox}
                      onChange={() => {
                        setLogoutAllDevicesCheckbox(!logoutAllDevicesCheckbox);
                      }}
                    >
                      Logout all Devices
                    </Checkbox>
                  </Form.Item>

                  <div
                    style={{
                      color: "#757575",
                      fontSize: 12,
                      marginTop: 20,
                      marginBottom: 20,
                      fontWeight: 400,
                      cursor: "pointer",
                    }}
                    onClick={navigateToLoginScreen}
                  >
                    Login Instead
                  </div>
                  <Form.Item className="login-button-section">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={user.loading}
                      className={"loginFormButton"}
                    >
                      RESET PASSWORD
                    </Button>
                    <div style={{ textAlign: "center", margin: "1%" }}></div>
                  </Form.Item>
                </Form>
              </>
            );
          }}
        />
      </Card>
      <PopupModal
        title={"Check your Email"}
        centered
        visible={!user.loading && !user.error && user.success}
        // onOk={() => sendForgotPasswordRequest()}
        onCancel={navigateToLoginScreen}
        footer={[
          <Button key="submit" type="link" onClick={navigateToLoginScreen}>
            OKAY
          </Button>,
        ]}
      >
        <span>
          We have sent you an email with temporary password. Please use that
          password to log in and set your new password
        </span>
      </PopupModal>
      <PopupModal
        title={"Failed to reset password"}
        centered
        visible={!user.loading && user.error && !user.success}
        // onOk={() => sendForgotPasswordRequest()}
        onCancel={navigateToLoginScreen}
        footer={[
          <Button key="submit" type="link" onClick={navigateToLoginScreen}>
            OKAY
          </Button>,
        ]}
      >
        {user.error}
      </PopupModal>
    </>
  );
};

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = (dispatch) => ({
  forgotPassword: bindActionCreators(userActions.forgotPassword, dispatch),
  resetUser: bindActionCreators(userActions.resetUser, dispatch),
});

ForgotPasswordForm.propTypes = {
  user: PropTypes.object,
  forgotPassword: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      redirectUrl: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm);
